/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/verfuegbarkeits-info-button/shop.verfuegbarkeits-info-button.component.ts.
 */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Verfuegbarkeitsanfrage} from '../../models/verfuegbarkeitsanfrage';
import {
  ShopArtikelVerfuegbarkeitInfoComponent
} from '../artikel-verfuegbarkeit-info/shop.artikel-verfuegbarkeit-info.component';
import {View} from '../../../../models/view';
import {Artikel} from '../../../../models/artikel';
import {BehaviorSubject, Subject} from 'rxjs';
import {AppViewService} from '../../../../services/app.view.service';
import {AppEventService} from '../../../../services/app.event.service';
import {AppMessageService} from '../../../../services/app.message.service';
import {map, takeUntil} from 'rxjs/operators';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppSnackbarService} from '../../../../services/app.snackbar.service';
import {AppSupplierService} from '../../../../services/app.supplier.service';
import {Supplier} from '../../../../models/supplier';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {ShopSupplierMenuComponent} from '../supplier-menu/shop.supplier-menu.component';
import {AppConfigService} from '../../../../services/app.config.service';
import {AppUserService} from '../../../../services/app.user.service';

/**
 * Zweck: Beschreibt class ShopVerfuegbarkeitsInfoButtonComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'verfuegbarkeits-info-button',
    templateUrl: 'shop.verfuegbarkeits-info-button.component.html',
    styleUrls: ['shop.verfuegbarkeits-info-button.component.scss'],
    standalone: false
})
export class ShopVerfuegbarkeitsInfoButtonComponent implements OnInit, OnDestroy {
  @Input() view: View;
  @Input() view_slug: string;
  @Input() artikel: Artikel;
  @Input() disabled = false;
  @Input() entry: WarenkorbEntry;
  @Input() supplierId: any;

  not_available_de_no_pzn = false;

  vfcheckloading = new BehaviorSubject<boolean>(false);
  vfcheckloading$ = this.vfcheckloading.asObservable();
  vfchecknotloading$ = this.vfcheckloading.asObservable().pipe(map(s => {
    return !s;
  }));

  supplier = new BehaviorSubject<Supplier[]>([]);

  _onDestroy = new Subject<void>();

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppViewService, private snackBarSvc: AppSnackbarService, private esvc: AppEventService,
              private bottomsheet: MatBottomSheet, private cfg: AppConfigService, private usvc: AppUserService,
              private msg: AppMessageService, private cd: ChangeDetectorRef, private ssvc: AppSupplierService) {
  }

/**
 * Beschreibt Methode showMenu und ihren Rückgabevertrag.
 */
  showMenu(event, as_vertreter = false) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.cfg.featuresEnabled(['Lieferantenbestellung'])) {
      this.usvc.hasRoles(['Lieferantenbestellung']).subscribe(hasRole => {
        if (hasRole) {
          setTimeout(() => {
            const bs = this.bottomsheet.open(ShopSupplierMenuComponent, {
              data: {
                artikel: this.artikel,
                entry: this.entry,
              }
            });

            bs.afterDismissed().subscribe(r => {
              if (r instanceof Supplier) {
                this.checkVerfuerbarkeit(r.id);
              }
            });
          }, 100);
        }
      });
    }
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode getViewSlug und ihren Rückgabevertrag.
 */
  getViewSlug() {
    if (this.view) {
      return this.view.slug;
    } else if (this.view_slug) {
      return this.view_slug;
    } else if (this.entry) {
      return this.entry.view_slug;
    } else {
      return '';
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.ssvc.supplier.pipe(takeUntil(this._onDestroy)).subscribe(s => {
      this.supplier.next(s);
    });
    this.not_available_de_no_pzn = !this.artikel.isVFStatusPruefbar();

    this.esvc.getQueue().pipe(takeUntil(this._onDestroy)).subscribe(e => {
     if (e.name == 'gui.view_article_changed' && e.data == this.artikel.ArtikelNummer) {
        this.detectChanges();
      }
    });
    this.detectChanges();
  }

/**
 * Beschreibt Methode checkVerfuerbarkeit und ihren Rückgabevertrag.
 */
  checkVerfuerbarkeit(supplierId: any = null) {
    this.vfcheckloading.next(true);
    this.detectChanges();
    if (supplierId == null && this.supplierId) {
      supplierId = this.supplierId;
    }
    this.svc.verfuegbarkeitBySlug(this.getViewSlug(), this.artikel, this.entry.menge, supplierId).subscribe({
      next: (s) => {
        if (s) {
          const d = new Verfuegbarkeitsanfrage();
          d.artikel = this.artikel;
          d.status = s;
          this.vfcheckloading.next(false);
          this.detectChanges();
          this.snackBarSvc.open(ShopArtikelVerfuegbarkeitInfoComponent, d, 20000);

        } else {
          this.msg.error('Leider ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut!');
          this.vfcheckloading.next(false);
        }
      },
      error: (e) => {
        if (e.error && e.error.message) {
          this.msg.error(e.error.message);
        } else {
          this.msg.error('Leider ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut!');
        }

        this.vfcheckloading.next(false);
      }
    });
  }
}
